import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'
import Signup from '@/components/Signup'
import Signin from '@/components/Signin'
import Post from '@/components/Post'
import Root from '@/components/Root'
import Youkou from '@/components/Youkou'
import Privacy from '@/components/Privacy'
import About from '@/components/About'
import Evaluate from '@/components/Evaluate'
import Recent from '@/components/Recent'
import Body from '@/components/Body'
import nomatch from '@/components/Nomatch'
import firebase from 'firebase/app';
import Award from '@/components/Award'


Vue.use(Router)

let router = new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    build: {
        publicPath: '/',
        productionSourceMap: false,

        // Remove unused CSS
        // Disable it if it has side-effects for your specific app
        purifyCSS: true
    },
    routes: [
        {
            path: '/',
            name: 'Root',
            component: Root,
        },
        {
            path: '/Youkou',
            name: 'Youkou',
            component: Youkou,
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy,
        },
        {
            path: '/about',
            name: 'About',
            component: About,
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup
        },
        {
            path: '/signin',
            name: 'Signin',
            component: Signin
        },
        {
            path: '/Evaluate',
            name: 'Evaluate',
            component: Evaluate,
        },
        {
            path: '/Recent',
            name: 'Recent',
            component: Recent,
        },
        {
            path: '/Recent/:id',
            name: 'body',
            component: Body,
        },
        {
            path: '/Award',
            name: 'Award',
            component: Award,
        },
        {
            path: '/Award/:id',
            name: 'awardbody',
            component: Body,
        },
        {
            path: '/Post',
            name: 'Post',
            component: Post,
            //meta: { requiresAuth: true }
        },
        {
            path: '*',
            name: 'nomatch',
            component: nomatch,
        }
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth) {
        console.log("hoge")
        firebase.auth().onAuthStateChanged(function (user) {
            if (user && user.emailVerified) {
                next()
            } else {
                next({
                    name: 'Signin'
                })
            }
        })
    } else {
        next() // next() を常に呼び出すようにしてください!
    }
})

export default router